import { useState, useCallback } from "react";
import { useUser } from "src/shared/context/UserContext";

export const useOrderPagination = (initialRows = 10, onPageFetch?: (page: number, rows: number) => void) => {
  const [page, setPage] = useState(0);
  const{userConfigration}=useUser()
  const [rowsPerPage, setRowsPerPage] = useState(userConfigration?.tableDefaultSize || initialRows);

  const handleChangePage = useCallback(
    (_: unknown, newPage: number) => {
      setPage(newPage);
      if (onPageFetch) onPageFetch(newPage + 1, rowsPerPage); // API is 1-indexed
    },
    [rowsPerPage, onPageFetch]
  );

  const handleChangeRowsPerPage = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newRows = parseInt(event.target.value, 10);
      setRowsPerPage(newRows);
      setPage(0);
      if (onPageFetch) onPageFetch(1, newRows);
    },
    [onPageFetch]
  );

  return { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, setPage, setRowsPerPage };
};
